// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { Icon as OldIcon } from '../Icon'
import { IconSquircle } from '../IconSquircle'
import { ProfilePicture } from '../ProfilePicture'
import { colors } from '@lmc/common/constants'
import { Button, Icon, IconType, Text } from '@lmc/ui-kit'
import { Tooltip } from 'antd'

export default class IconSectionHeader extends React.Component<any, any> {
  renderImgIcon() {
    const { iconUrl, color } = this.props
    return (
      <IconSquircle
        color={color}
        disabled
        isListView={false}
        size={40}
        icon={iconUrl}
      />
    )
  }

  renderSVGIcon() {
    const { icon, color } = this.props
    return (
      <div
        style={{
          ...styles.iconContainer,
          background: color || colors.grey,
        }}
      >
        {icon ? <OldIcon fill={colors.white} name={icon} size={20} /> : null}
      </div>
    )
  }

  renderIconText() {
    const { iconText, color } = this.props
    return (
      <div
        style={{
          ...styles.iconContainer,
          background: color || colors.grey,
        }}
      >
        {iconText ? <span style={styles.iconText}>{iconText}</span> : null}
      </div>
    )
  }

  renderProfilePicture() {
    const { profilePicture } = this.props
    return <ProfilePicture url={profilePicture} size={40} />
  }

  renderButton() {
    const { buttonLabel, onClickButton, buttonDisabled, buttonTooltip } = this.props
    const button = (
      <Button
        variant="primary"
        onClick={() => !buttonDisabled && onClickButton()}
        disabled={buttonDisabled}
        icon={
          <Icon
            customIcon={IconType.Signature}
            style={styles.signatureIcon}
          />
        }
      >
        {buttonLabel}
      </Button>
    )

    return (
      <div style={styles.buttonRow}>
        {buttonDisabled && buttonTooltip ? (
          <Tooltip title={buttonTooltip}>
            <span>{button}</span>
          </Tooltip>
        ) : (
          button
        )}
      </div>
    )
  }

  render() {
    const {
      buttonLabel,
      icon,
      iconUrl,
      iconText,
      profilePicture,
      isMainHeader,
      title,
      subtitle,
      noWrapContainer,
    } = this.props

    return (
      <div style={styles.wrapper}>
        {icon && this.renderSVGIcon()}
        {iconUrl && this.renderImgIcon()}
        {iconText && this.renderIconText()}
        {profilePicture && this.renderProfilePicture()}
        <div
          style={{
            ...styles.titleContainer,
            ...(!noWrapContainer && styles.titleContainerWrap),
            paddingLeft: icon || iconUrl || iconText || profilePicture ? 15 : 0,
          }}
        >
          <div
            style={{
              ...styles.titleSubcontainer,
              ...(!noWrapContainer && styles.titleSubcontainerWrap),
            }}
          >
            <Text
              as="h2"
              style={{
                color: colors.black,
                display: 'flex',
                marginBottom: '-4px',
                fontWeight: 400,
              }}
            >
              {title} {buttonLabel && this.renderButton()}
            </Text>
          </div>
          {subtitle && (
            <span
              style={{
                ...styles.subtitle,
                ...(!noWrapContainer && styles.subtitleWrap),
              }}
            >
              {subtitle}
            </span>
          )}
        </div>
      </div>
    )
  }
}

const styles = {
  button: {
    float: 'right',
    fontSize: 14,
  },
  divider: {
    background: colors.grey,
    height: 2,
    width: '100%',
  },
  iconContainer: {
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    width: 40,
  },
  iconText: {
    color: colors.white,
    fontSize: 12,
    fontWeight: 'bold',
  },
  signatureIcon: {
    transform: 'translate(-4px, 0px)',
    fill: 'none',
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 300,
    opacity: 0.9,
  },
  subtitleWrap: {
    display: 'flex',
  },
  title: {
    marginBottom: 0,
    display: 'flex',
  },
  titleWrap: {
    width: 'max-content',
  },
  titleContainer: {
    flex: 1,
  },
  titleContainerWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  titleSubcontainer: {
    minHeight: 34,
  },
  titleSubcontainerWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    display: 'flex',
    // I think this is not needed
    // TODO: check here if this component gets broken
    // width: '100%',
  },
  buttonRow: { marginLeft: 'auto', marginTop: 5 },
}

IconSectionHeader.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  iconUrl: PropTypes.string,
  isMainHeader: PropTypes.bool,
  customSignButton: PropTypes.bool,
  noWrapContainer: PropTypes.bool,
  title: PropTypes.string.isRequired,
  buttonDisabled: PropTypes.bool,
  buttonTooltip: PropTypes.string,
}
